import { render, staticRenderFns } from "./session-sidebar.vue?vue&type=template&id=73b3387e&scoped=true"
import script from "./session-sidebar.vue?vue&type=script&lang=ts"
export * from "./session-sidebar.vue?vue&type=script&lang=ts"
import style0 from "./session-sidebar.vue?vue&type=style&index=0&id=73b3387e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b3387e",
  null
  
)

export default component.exports